<template>
  <div class=" advance-charge-info">

    <div class="section" style="flex: 1;">
      <div v-show="isAllowedEdit" class="operations">
        <div class="triggers">
          <div style="display: flex;">
            <span class="title">{{ $t('FinanceManage.adChargeInfo_prepaid') }}</span>
            <charge-currency-total-group
              v-if="reCalc"
              ref="apTotalGroup"
              no="apTotalGroup"
              :amount-to-currency="localCurrency"
              :data-provider="adList.apTotalGroup"
              :data-field="'amount'"
              rate-field="exchangeRate"
              :is-gross-profit="true"
              type="ap"
            />
          </div>
          <cargo-button-group-slider no="top" align="right" style="flex:1; border: none">
            <div v-show="viewSource!=='salesDetail'">
              <el-button
                v-show="isAllowedEdit"
                no="adChargeInfo_print"
                :disabled="!(!isEdit && advanceSelected) || !advanceSelected"
                type="success"
                @click="print"
              >{{ $t('FinanceManage.adChargeInfo_print') }}
              </el-button>
              <el-button
                v-show="isAllowedEdit"
                no="adChargeInfo_newAdjustment"
                :disabled="!(job && job.jobState === 2)"
                type="primary"
                @click="addCostAdjust('add', false)"
              >{{ $t('FinanceManage.adChargeInfo_newAdjustment') }}
              </el-button>
              <el-button
                v-show="isAllowedEdit"
                no="adChargeInfo_editAdjustment"
                :disabled="!(job && job.jobState === 2 && advanceSelected && !(advanceSelected.billingUuid || advanceSelected.invoiceUuid || advanceSelected.billingPaymentUuid || advanceSelected.confirmBillUuid || advanceSelected.verifiedAmount !== 0))"
                type="primary"
                @click="addCostAdjust('edit', false)"
              >
                {{ $t('FinanceManage.adChargeInfo_editAdjustment') }}
              </el-button>
              <el-button
                v-show="isAllowedEdit"
                no="adChargeInfo_deleteAdjustment"
                :disabled="!(job && job.jobState === 2 && advanceSelected && !(advanceSelected.billingUuid || advanceSelected.invoiceUuid || advanceSelected.billingPaymentUuid || advanceSelected.confirmBillUuid || advanceSelected.verifiedAmount !== 0))"
                type="danger"
                @click="addCostAdjust('del', false)"
              >
                {{ $t('FinanceManage.adChargeInfo_deleteAdjustment') }}
              </el-button>
              <el-button no="adChargeInfo_addBoth" :disabled="!(isEdit && btn.btBothAdd)" type="primary" @click="bothAddChargeHandler">
                {{ $t('FinanceManage.adChargeInfo_addBoth') }}
              </el-button>
              <el-button no="adChargeInfo_add" :disabled="!isEdit" type="primary" @click="addAdvanceHandler">
                {{ $t('FinanceManage.adChargeInfo_add') }}
              </el-button>
              <el-button no="adChargeInfo_delete" :disabled="!(isEdit && btn.btDel2)" type="danger" @click="delAdvChargeHandler">
                {{ $t('FinanceManage.adChargeInfo_delete') }}
              </el-button>
              <el-button
                v-show="isChargeSubmitDirect && !adjust && isSubmitChargeRole"
                no="adChargeInfo_submitCharge"
                :disabled="isEdit || !advanceSelected || (advanceSelected && Number(advanceSelected.chargeState) !== 0)"
                type="primary"
                @click="chargeSubmitEventHandler(1,true)"
              >
                {{ $t('FinanceManage.adChargeInfo_submitCharge') }}
              </el-button>
              <el-button
                v-show="isChargeSubmitDirect && !adjust && isCancelSubmitChargeRole"
                no="adChargeInfo_cancelSubmit"
                :disabled="isEdit || !advanceSelected || (advanceSelected && Number(advanceSelected.chargeState) !== 1)"
                type="primary"
                @click="chargeSubmitEventHandler(0,true)"
              >
                {{ $t('FinanceManage.adChargeInfo_cancelSubmit') }}
              </el-button>
            </div>
          </cargo-button-group-slider>
        </div>
      </div>
      <cargo-ag-grid
        no="130114"
        config-module="130114"
        :grid-options="up.gridOptions"
        :grid-params.sync="up.gridParams"
        :column-defs="dynamicColumnDefsForUp"
        :row-data="up.rowData"
        style="flex-grow:1;margin-top:5px"
        @gridReady="params=>up.gridApi=params.api"
      />
    </div>
    <div class="section" style="flex: 1;">
      <div v-show="isAllowedEdit" class="operations">
        <div class="triggers" style="height: 28px">
          <div style="display: flex;">
            <span class="title">{{ $t('FinanceManage.adChargeInfo_collect') }}</span>
            <charge-currency-total-group
              v-if="reCalc"
              ref="arTotalGroup"
              no="arTotalGroup"
              :amount-to-currency="localCurrency"
              :data-provider="adList.arTotalGroup"
              :data-field="'amount'"
              rate-field="exchangeRate"
              :is-gross-profit="true"
              type="ar"
            />
          </div>
          <cargo-button-group-slider no="bottom" align="right" style="flex:1; border: none">
            <div v-show="viewSource!=='salesDetail'" style="float:right">
              <el-button
                v-show="isAllowedEdit"
                no="adChargeInfo_newAdjustment"
                :disabled="!(job && job.jobState === 2)"
                type="primary"
                @click="addCostAdjust('add', true)"
              >{{ $t('FinanceManage.adChargeInfo_newAdjustment') }}
              </el-button>
              <el-button
                v-show="isAllowedEdit"
                no="adChargeInfo_editAdjustment"
                :disabled="!(job && job.jobState === 2 && agentSelected && !(agentSelected.billingUuid || agentSelected.invoiceUuid || agentSelected.billingPaymentUuid || agentSelected.confirmBillUuid || agentSelected.verifiedAmount !== 0))"
                type="primary"
                @click="addCostAdjust('edit', true)"
              >
                {{ $t('FinanceManage.adChargeInfo_editAdjustment') }}
              </el-button>
              <el-button
                v-show="isAllowedEdit"
                no="adChargeInfo_deleteAdjustment"
                :disabled="!(job && job.jobState === 2 && agentSelected && !(agentSelected.billingUuid || agentSelected.invoiceUuid || agentSelected.billingPaymentUuid || agentSelected.confirmBillUuid || agentSelected.verifiedAmount !== 0))"
                type="danger"
                @click="addCostAdjust('del', true)"
              >
                {{ $t('FinanceManage.adChargeInfo_deleteAdjustment') }}
              </el-button>
              <el-button no="adChargeInfo_add" :disabled="!isEdit" type="primary" @click="addAgentHandler">
                {{ $t('FinanceManage.adChargeInfo_add') }}
              </el-button>
              <el-button no="adChargeInfo_delete" :disabled="!(isEdit && btn.btDel1)" type="danger" @click="delAgentChargeHandler">
                {{ $t('FinanceManage.adChargeInfo_delete') }}
              </el-button>
              <!--代收：提交/取消提交费用 使用条件：1、查看 2、选中费用 3、费用状态为未提交-->
              <el-button
                v-show="isChargeSubmitDirect && !adjust && isSubmitChargeRole"
                no="adChargeInfo_submitCharge"
                :disabled="isEdit || !agentSelected || (agentSelected && Number(agentSelected.chargeState) !== 0)"
                type="primary"
                @click="chargeSubmitEventHandler(1)"
              >
                {{ $t('FinanceManage.adChargeInfo_submitCharge') }}
              </el-button>
              <el-button
                v-show="isChargeSubmitDirect && !adjust && isCancelSubmitChargeRole"
                no="adChargeInfo_cancelSubmit"
                :disabled="isEdit || !agentSelected || (agentSelected && Number(agentSelected.chargeState) !== 1)"
                type="primary"
                @click="chargeSubmitEventHandler(0)"
              >
                {{ $t('FinanceManage.adChargeInfo_cancelSubmit') }}
              </el-button>
            </div>
          </cargo-button-group-slider>
        </div>
      </div>
      <cargo-ag-grid
        no="130113"
        config-module="130113"
        :grid-options="down.gridOptions"
        :grid-params.sync="down.gridParams"
        :column-defs="dynamicColumnDefsForDown"
        :row-data="down.rowData"
        style="height: 100%;width:100%;margin-top:5px"
        @gridReady="params=>down.gridApi=params.api"
      />
      <div class=" operations" style="margin-top: 10px">
        <span>{{ $t('CargoMsg.Cargo_Difference') }}</span>
        <charge-currency-total-group
          v-if="reCalc"
          no="Difference"
          :amount-to-currency="localCurrency"
          :data-field="'amount'"
          :data-provider="adList.revenueTotalGroup"
          rate-field="exchangeRate"
          :is-gross-profit="true"
          type="revenue"
        />
      </div>
    </div>

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
    />

    <!-- 增加/删除/修改调整 -->
    <adjust-window
      ref="adjustWindow"
      :visible.sync="adjustWindow.visible"
      :default-properties="adjustWindow.defaultProperties"
      :location="location"
      @returnCall="callbackHandler"
    />
  </div>
</template>

<script>

import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Job } from '@/class/model/booking/Job'
import { Charge } from '@/class/model/act/Charge'
import { cache, cacheName } from '@/utils/cacheManager'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { chargeSubmit } from '@/api/clearing/charge'
import adjustWindow from '@/components/Cargo/Job/adjustWindow'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import DateUtils from '@/utils/dateUtils'
import { TabError } from '@/utils/class/TabError'
import { Company } from '@/class/model/mdm/Company'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { IntegratedJob } from '@/class/model/booking/IntegratedJob'
import { sortByMultiField, getUuid } from '@/utils'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import * as NumberUtils from '@/utils/NumberUtils'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'

export default {
  name: 'TabAdvanceCharge',
  components: { CargoButtonGroupSlider, cargoTemplateSelectorDialog, adjustWindow, ChargeCurrencyTotalGroup },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    adjust: { type: Boolean, required: false, default: false },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    location: { type: String, required: false }
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        chargeMeasureSet: [], // 费用单位
        currencySet: [], // 币种
        chargeItemSet: new Set()
      },
      loading: null,
      isRefresh: false,
      isAllowedEdit: true, // 操作通常允许文件上传与删除，销售只允许查看，不能编辑。
      agentSelected: null, // 代收选中费用
      advanceSelected: null, // 垫付选中费用
      up: { // 垫付
        chooseUuidSet: new Set(),
        gridOptions: {},
        gridParams: {},
        columnDefs: [],
        rowData: [],
        gridApi: null,
        isSelect: false
      },
      down: { // 代收
        chooseUuidSet: new Set(),
        gridOptions: {},
        gridParams: {},
        columnDefs: [],
        rowData: [],
        gridApi: null,
        isSelect: false
      },
      adList: {
        arTotalGroup: [],
        apTotalGroup: [],
        revenueTotalGroup: []
      },
      isSubmitChargeRole: false, // 提交费用权限
      isCancelSubmitChargeRole: false, // 取消提交费用权限
      checkAdvanceChargeTotal: false, // 代收垫付是否允许收支不平衡
      isChargeSubmitDirect: false, // 是否直接提交审核费用
      job: new Job().fillDefaultValue().getData(),
      MAX_CHARGE: 999,
      btn: {
        btBothAdd: false,
        btDel1: false,
        btDel2: false
      },
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      adjustWindow: {
        visible: false,
        defaultProperties: {} // 费用调整默认条件
      },
      charges: [], // 修改/新增存在此集合中，若uuid不为空则修改，为空则新增, 存完整的费用数据
      delChargeUuids: [] // 删除存在此集合中，存费用uuid
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    },
    user() {
      return this.context.user || {}
    },
    officeList() {
      return this.context.officeList
    },
    dynamicColumnDefsForUp() {
      return this.getDynamicColumnDefsForUp()
    },
    dynamicColumnDefsForDown() {
      return this.getDynamicColumnDefsForDown()
    }
  },
  async created() {
    this.up.gridOptions = { // 垫付
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      rowSelection: 'multiple',
      singleClickEdit: true,
      frameworkComponents: {
        CargoAgGridAdvanceSelectEditor,
        CargoAgGridCommonInputEditor,
        CargoAgGridSelectEditor
      },
      getRowStyle: (params) => {
        const chargeData = params.data
        if (this.isRowEdit(chargeData)) {
          return { background: '#FFFFFF' }
        } else {
          return { background: '#C0C0C0' }
        }
      },
      // 选中 勾选框或者其他列 都会触发
      onCellFocused: (event) => {
        this.onUpCellFocused(event)
      },
      // 选中 勾选框触发
      onRowSelected: (event) => {
        this.onUpRowSelected(event)
        this.updateButtonState()
      }
    }
    this.down.gridOptions = { // 代收
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      rowSelection: 'multiple',
      singleClickEdit: true,
      frameworkComponents: {
        CargoAgGridAdvanceSelectEditor,
        CargoAgGridCommonInputEditor,
        CargoAgGridSelectEditor
      },
      getRowStyle: (params) => {
        const chargeData = params.data
        if (this.isRowEdit(chargeData)) {
          return { background: '#FFFFFF' }
        } else {
          return { background: '#C0C0C0' }
        }
      },
      // 选中 勾选框或者其他列 都会触发
      onCellFocused: (event) => {
        this.onDownCellFocused(event)
      },
      // 选中 勾选框触发
      onRowSelected: (event) => {
        this.onDownRowSelected(event)
        this.updateButtonState()
      }
    }
    await cache.load(cacheName.CONFIG)
    this.setLocalCurrency()
  },
  methods: {
    onUpCellFocused(event) {
      if (this.up.gridApi && event.column) {
        this.up.gridApi.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.advanceSelected = node.data
            console.log('selectedRow============')
          }
        })
      }
    },
    onUpRowSelected(event) {
      if (event.node.isSelected()) {
        this.advanceSelected = event.node.data
        this.up.chooseUuidSet.delete(event.data.uuid)
      }
    },
    toResetUpSelected() {
      this.up.gridApi.forEachNode(node => {
        node.selectThisNode(this.up.chooseUuidSet.has(node.data.uuid))
      })
    },
    onDownCellFocused(event) {
      if (this.down.gridApi && event.column) {
        this.down.gridApi.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            this.agentSelected = node.data
            console.log('selectedRow============')
          }
        })
      }
    },
    onDownRowSelected(event) {
      if (event.node.isSelected()) {
        this.agentSelected = event.node.data
        this.down.chooseUuidSet.delete(event.data.uuid)
      }
    },
    toResetDownSelected() {
      this.down.gridApi.forEachNode(node => {
        node.selectThisNode(this.down.chooseUuidSet.has(node.data.uuid))
      })
    },
    // 公用方法
    async onShow(row, isRefresh) {
      this.$logger.log('tabCharges onShow isRefresh', isRefresh)
      this.loading = getLoading4Cxt(this)
      try {
        this.isRefresh = isRefresh
        this.job = row
        switch (row.lob) {
          case 'SE':
            this.job = new SeaExportJob(row)
            break
          case 'SI':
            this.job = new SeaImportJob(row)
            break
          case 'AE':
            this.job = new AirExportJob(row)
            break
          case 'AI':
            this.job = new AirImportJob(row)
            break
          case 'RE':
          case 'RI':
            this.job = new RailwayExportJob(row)
            break
          case 'IE':
            this.job = new IntegratedJob(row)
            break
        }
        await this.initializeHandler()
        await this.commitProperties()
      } finally {
        this.loading.close()
      }
    },
    // 获取选中行，根据type区分代收【'down'】垫付【'up'】
    readSelectedRows(type, tips = true) {
      let rows = this.up.gridApi.getSelectedRows()
      if (type === 'down') {
        rows = this.down.gridApi.getSelectedRows()
      }
      if (rows.length === 0 && tips) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      return rows
    },
    async commitProperties() {
      if (this.job) {
        await this.loadCharges()
      }
    },
    // 初始化权限及配置参数
    initializeHandler() {
      // 初始赋值，避免仍保留上次的值
      this.agentSelected = null
      this.advanceSelected = null
      this.up.rowData = []
      this.down.rowData = []
      if (this.isRefresh) {
        this.charges = []
      }
      this.delChargeUuids = []
      // 配置项
      this.checkAdvanceChargeTotal = parseInt(cache.config.get('CheckAdvanceChargeTotal')) === 1
      this.isChargeSubmitDirect = parseInt(cache.config.get('ChargeSubmitDirect')) === 1
      // 权限
      this.isSubmitChargeRole = this.$checkPermission(['button_Charge_submitCharge'])
      this.isCancelSubmitChargeRole = this.$checkPermission(['button_Charge_cancelSubmitCharge'])
    },
    // 加载费用数据
    async loadCharges() {
      const job = this.job
      if (job) {
        // 从数据库中加载数据
        if ((this.isEdit && this.isRefresh && (!this.job.charges || this.job.charges.length <= 0)) || !this.isEdit) {
          job.charges = ''
        }
        this.$logger.log('job.charges', job.charges)
        await job.getCharges()
        this.$logger.log('job.charges1', job.charges)
      }
      await this.initGridSpareData()
      this.loadChargesResultHandler()
    },
    // 初始化列表所需的缓存数据
    async initGridSpareData() {
      this.initChargeMeasureSet()
      this.initCurrencySet()
      this.initChargeItemSet()
    },
    // 费用方案缓存数据
    initChargeMeasureSet() {
      const seaFreight = true
      const chargeMeasureSet = new Set()
      for (const item of ChargeMeasure.CHARGE_MEASURES) {
        if (item.forSeaFreight && seaFreight) {
          chargeMeasureSet.add(item)
        }
      }
      this.currentViewCacheData.chargeMeasureSet = Array.from(chargeMeasureSet)
    },
    // 币种缓存数据
    initCurrencySet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      this.currentViewCacheData.currencySet = Array.from(new Set(results))
    },
    initChargeItemSet() {
      let results = chargeItemCompatibleLanguage()
      if (results && results.length > 0) {
        results = results.filter(p => !!p.active)
      }
      this.currentViewCacheData.chargeItemSet = new Set(results)
    },
    // 获取费用成功后事件
    loadChargesResultHandler() {
      this.extractCharges()
      this.updateButtonState()
    },
    // 给表格设置数据源
    extractCharges() {
      this.down.rowData = []
      this.up.rowData = []
      for (const charge of this.job.charges) {
        if (RateUtil.useOrderCenterMode() && charge.branchId !== this.$store.getters.currentOfficeId) {
          continue
        }
        if (charge.advance) {
          if (charge.receivable) {
            this.down.rowData.push(charge)
          } else {
            this.up.rowData.push(charge)
          }
        }
      }
      //  排序 cargo 这边直接是 job.charges , h5这边经确认根据 修改日期降序
      if (this.up.rowData && this.up.rowData.length > 1) {
        sortByMultiField(this.up.rowData, ['dateModified'], true) // 降序
      }
      if (this.down.rowData && this.down.rowData.length > 1) {
        sortByMultiField(this.down.rowData, ['dateModified'], true) // 降序
      }
      this.getAdList()
    },
    // 刷新按钮状态
    updateButtonState() {
      if (!this.isEdit) return
      this.btn.btBothAdd = this.down.rowData == null || this.down.rowData.length < this.MAX_CHARGE
      this.btn.btDel1 = this.isRowEdit(this.agentSelected)
      this.btn.btDel2 = this.isRowEdit(this.advanceSelected)
    },
    // 是否可编辑列
    isEditColumn(params) {
      const dataField = params.colDef.field
      const charge = params.data
      if (charge) {
        if (dataField === 'oversea' && parseInt(cache.config.get('canChangeOverseaOfCharge')) === 0) {
          return false
        }
      }
      return true
    },
    isRowEdit(item) {
      if (!item || item.billingUuid || item.invoiceUuid || !item.jobUuid || Number(item.verifiedAmount) !== 0 || item.billingPaymentUuid || item.confirmBillUuid || item.shared || Number(item.chargeState) > 0 || !this.internalEnable(item)) {
        return false
      }
      return true
    },
    // 内结费用
    internalEnable(item) {
      if (RateUtil.useOrderCenterMode()) {
        if (item.internalFrom) {
          return false
        } else {
          if (item.internalTo) {
            for (const internal of this.job.charges) {
              if (internal.internal && internal.chargeId === item.internalTo) {
                return !(internal.billingUuid || internal.invoiceUuid || internal.billingPaymentUuid || internal.confirmBillUuid || internal.verifiedAmount !== 0)
              }
            }
          }
        }
        return true
      } else {
        return true
      }
    },
    // 同时新增
    bothAddChargeHandler() {
      this.addAgentHandler()
      this.addAdvanceHandler()
    },
    // 新增垫付
    async addAdvanceHandler() {
      this.addChargeHandler(false)
    },
    // 新增代收
    async addAgentHandler() {
      this.addChargeHandler(true)
    },
    // 新增公共
    async addChargeHandler(receivable) {
      const charge = await this.createCharge()
      charge.receivable = receivable
      await ChargeUtils.chargeItemChange(charge, this.job)
      if (parseInt(cache.config.get('canChangeOverseaOfCharge')) === 2) {
        charge.oversea = false
      } else if (parseInt(cache.config.get('canChangeOverseaOfCharge')) === 3) {
        charge.oversea = true
      }
      charge.needInvoice = false
      await ChargeColumnUtil.getInvoiceTitle(charge)
      this.$logger.log('新增的费用 charge：', charge)
      if (receivable) {
        this.down.rowData.push(charge)
      } else {
        this.up.rowData.push(charge)
      }
      // 将新增的费用加入job,作用是在编辑状态下切换不同页签，当前页签新增的费用不会丢失
      if (!this.job.charges) this.job.charges = []
      this.job.charges.push(charge)
      this.saveCharges(charge, null, null)
      this.updateButtonState()
    },
    // 创建费用
    async createCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.uuid = this.uuidPrefixRule + getUuid()
      charge.advance = true
      charge.jobUuid = this.job.uuid
      charge.businessDate = this.job.businessDate
      charge.accountId = this.job.customerId
      charge.inputBy = this.$store.getters.userId
      charge.inputDate = new Date()
      charge.inputByDep = this.$store.getters.currentDeptId
      charge.branchId = this.$store.getters.currentOfficeId
      charge.currency = 'USD'
      const localCurrency = RateUtil.localCurrencyByOffice()
      charge.localCurrency = localCurrency
      charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, this.job, charge.branchId)
      // HQ币种/汇率
      charge.hqCurrency = RateUtil.getHqCurrency(charge.branchId)
      charge.hqRate = await RateUtil.getForeignExchangeRateByJob(charge.hqCurrency, localCurrency, this.job, charge.branchId)
      charge.unitRate = 0
      charge.amount = 0
      charge.verifiedAmount = 0
      const chargeItem = await this.getAdvanceChargeItem()
      if (chargeItem && chargeItem.active) {
        charge.chargeItemId = chargeItem.itemId
        await this.refreshQuantity(charge)
        this.refreshAmount(charge)
      }
      await ChargeColumnUtil.getInvoiceTitle(charge)
      return charge
    },
    // 获取维护数据中的垫付费用
    getAdvanceChargeItem() {
      var items = getCacheListByKey(basicCacheKeys.basic_data_ChargeItem)
      let item = null
      for (const i of items) {
        if (i.advance) {
          item = i
          break
        }
      }
      return item
    },
    // 刷新单价
    async refreshUnitRate(charge) {
      if (charge.preCurrency !== charge.currency) {
        const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
        const oldExchange = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, this.job, charge.branchId)
        const oldUnitRate = charge.unitRate * oldExchange
        charge.unitRate = (oldUnitRate / charge.exchangeRate) || 0
        charge.preCurrency = charge.currency
      }
    },
    // 刷新费用金额
    refreshAmount(charge) {
      ChargeUtils.calculateTax(charge, charge.quantity * charge.unitRate, charge.taxRate)
    },
    // 刷新费用数量
    async refreshQuantity(item) {
      const measure = item.measure
      let quantity = item.quantity
      if (measure === ChargeMeasure.WGT_CHARGE_MEASURE.code) {
        quantity = this.job.weightActual / 1000
        if (quantity < 1) {
          quantity = 1
        }
      } else if (measure === ChargeMeasure.WGTT_CHARGE_MEASURE.code) {
        if (this.job.lob === 'SE' && BillType.MERGE_BILL_TYPE.code === this.job.typeHBL) {
          const hbl2 = this.job.seaCargoDoc.find(p => p.docType === CargoDocConsts.HBL2)
          if (hbl2 && hbl2.weight) {
            quantity = hbl2.weight / 1000
          }
        } else {
          quantity = this.job.weightActual / 1000
        }
        if (quantity < 1) {
          quantity = 1
        }
      } else if (measure === 'WGTX') {
        quantity = this.job.chargeWeight
      } else if (measure === 'VOL') {
        quantity = this.job.cubageActual
      } else if (measure === 'MIN') {
        quantity = 1
      } else if (measure === 'NML') {
        quantity = 1
      } else {
        quantity = await this.getEQQuantity(measure)
      }

      item.measure = measure
      item.quantity = quantity
    },
    // 获取数量
    async getEQQuantity(type) {
      let n = 0
      if (!this.job || !this.job.seaEQ) {
        await new Job(this.job).getSeaEQ()
      }
      if (this.job.seaEQ) {
        for (const eq of this.job.seaEQ) {
          if (type === 'C20') {
            if (eq.eqSize === '20') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C40') {
            if (eq.eqSize === '40' && eq.EQtype !== 'HQ') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C40H') {
            if (eq.eqSize === '40' && eq.EQtype === 'HQ') {
              n = n + eq.eqQuantity
            }
          } else if (type === 'C45') {
            if (eq.eqSize === '45') {
              n = n + eq.eqQuantity
            }
          }
        }
      }
      return n
    },
    // 删除垫付
    delAdvChargeHandler() {
      this.delChargeHandler('up')
    },
    // 删除代收
    delAgentChargeHandler() {
      this.delChargeHandler('down')
    },
    // 删除公共
    delChargeHandler(type) {
      const rows = this.readSelectedRows(type)
      if (rows && rows.length > 1) {
        this.$message.info('请选择一条数据进行删除！')
        return
      }
      const c = rows[0]
      if (c.invoiceUuid) {
        this.$message.info(this.$t('Message.TheBillHasBeenInvoicedAndCannotBeDeleted'))
      } else {
        if (type === 'down') {
          const index = this.down.rowData.indexOf(c)
          this.down.rowData.splice(index, 1)
        } else {
          const index = this.up.rowData.indexOf(c)
          this.up.rowData.splice(index, 1)
        }

        // 将费用从job移除
        if (this.job.charges && this.job.charges.length > 0) {
          for (const charge of this.job.charges) {
            if (charge.uuid === c.uuid) {
              const chargeIndex = this.job.charges.indexOf(charge)
              this.job.charges.splice(chargeIndex, 1)
            }
          }
        }

        this.saveCharges(null, null, c)
        this.updateButtonState()
      }
    },
    // 提交费用/取消提交
    async chargeSubmitEventHandler(chargeState, receivable = false) {
      let items = null
      if (receivable) {
        items = this.getChargeSelectItems(chargeState, 'up')
      } else {
        items = this.getChargeSelectItems(chargeState, 'down')
      }
      if (!items || items.length === 0) {
        this.$message.warning(chargeState === 1 ? this.$t('Message.ChargeIsNotSelectedOrAllChargesSubmit') : this.$t('Message.ChargeIsNotSelectedOrNotInTheSubmissionStatus'))
        return
      }
      const chargeKeys = Array.from(items, p => p.uuid)
      await chargeSubmit(chargeKeys, chargeState, this.location).then(res => {
        if (res.data && Number(res.data) > 0) {
          const rows = receivable ? this.up.rowData : this.down.rowData
          const objChargeKey = {}
          for (const chargeKey of chargeKeys) {
            objChargeKey[chargeKey] = chargeKey
          }
          for (const charge of rows) {
            if (chargeKeys.includes(charge.uuid) && objChargeKey[charge.uuid] === charge.uuid) {
              charge.chargeState = chargeState
              charge.version += 1
            }
          }
          if (receivable) {
            // 需要将已勾选的数据变成未勾选
            this.up.gridApi.deselectAll()
            // 刷新
            this.up.gridApi.refreshCells({ force: true })
            this.up.gridApi.redrawRows()
          } else {
            // 需要将已勾选的数据变成未勾选
            this.down.gridApi.deselectAll()
            // 刷新
            this.down.gridApi.refreshCells({ force: true })
            this.down.gridApi.redrawRows()
          }
          this.$message.success(this.$t('Message.OperationSuccessfully'))
        } else {
          this.$message.error(this.$t('SeaExport.OperationFailed'))
        }
      })
    },
    // 获取选中费用
    getChargeSelectItems(chargeState, type) {
      const items = []
      const rows = this.readSelectedRows(type, false)
      if (!rows) return []
      for (const charge of rows) {
        if (chargeState === 1 ? charge.chargeState === 0 : charge.chargeState === 1) {
          items.push(charge)
        }
      }
      return items
    },
    // 保存费用数据组装
    saveCharges(add = null, edit = null, del = null) {
      // 需要修改的数据库中存在的费用
      if (edit && edit.uuid && !this.charges.includes(edit)) {
        this.charges.push(edit)
      }

      // 需要新增的费用
      if (add && add.uuid.startsWith(this.uuidPrefixRule) && !this.charges.includes(add)) {
        add.uuid = ''
        this.charges.push(add)
      }
      // 删除
      if (del) {
        // 需要从数据库中删除的费用
        if (del.uuid && !this.delChargeUuids.includes(del.uuid)) {
          this.delChargeUuids.push(del.uuid)
        }
        // 刚刚新增的费用需要移除掉
        if (this.charges.includes(del)) {
          const index = this.charges.indexOf(del)
          if (index !== -1) {
            this.charges.splice(index, 1)
          }
        }
      }
    },
    // 保存数据
    getSubmitData() {
      this.$logger.log('代收垫付-charges', this.charges)
      this.$logger.log('代收垫付-delChargeUuids', this.delChargeUuids)
      this.validateForm()
      return {
        charges: this.charges, // 修改/新增存在此集合中，若uuid不为空则修改，为空则新增, 存完整的费用数据，这里只会存代收垫付的费用
        delChargeUuids: this.delChargeUuids // 删除存在此集合中，存费用uuid
      }
    },
    // 保存验证
    validateForm() {
      const advancePay = this.up.rowData
      const agentPay = this.down.rowData
      const tabName = 'tabAdvanceCharge'
      this.checkChargeTotalPrice(tabName)
      ChargeUtils.checkHasEmptyCharge(agentPay, tabName)
      ChargeUtils.checkHasEmptyCharge(advancePay, tabName)
      ChargeUtils.checkHasEmptyAccount(agentPay, tabName)
      ChargeUtils.checkHasEmptyAccount(advancePay, tabName)
      ChargeUtils.checkHasEmptyQuantity(agentPay, tabName)
      ChargeUtils.checkHasEmptyQuantity(advancePay, tabName)
      ChargeUtils.checkHasEmptyPrice(agentPay, tabName)
      ChargeUtils.checkHasEmptyPrice(advancePay, tabName)
    },
    checkChargeTotalPrice(tabName) {
      if (this.checkAdvanceChargeTotal) {
        const advancePay = this.up.rowData
        const agentPay = this.down.rowData
        const agentTotal = this.getTotal(agentPay)
        const advTotal = this.getTotal(advancePay)
        // 汇率转换 误差为0.1
        if (Math.abs(NumberUtils.roundHalfUp2(agentTotal - advTotal, 2)) > 0.01) {
          throw new TabError(this.$t('Message.CollectingInconsistentWithTheTotalAdvance'), tabName)
        }
      }
    },
    // 汇总
    getTotal(charges) {
      let total = 0
      for (const charge of charges) {
        if (RateUtil.useOrderCenterMode() && charge.branchId !== this.$store.getters.currentOfficeId) {
          continue
        }
        if (RateUtil.useOrderCenterMode() && charge.internalFrom) {
          continue
        }
        total += charge.amount * charge.exchangeRate
      }
      return total
    },
    // 打印[垫付]
    print() {
      const rows = this.readSelectedRows('up', false)
      if (!rows || rows.length === 0) {
        this.$message.info(this.$t('Message.PleaseSelectTheDesiredPrintInformation'))
        return
      }
      const printKeys = Array.from(rows, p => p.uuid)
      const params = { CHARGE_UUID: printKeys, classNameType: SystemConstants.ACT, className: 'Charge', jobuuid: this.job.uuid }
      const charge = rows[0]
      this.templateSelectorDialog.ctx = new Charge(charge)
      this.templateSelectorDialog.category = 'ADVANCE_CHARGE'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
      // TemplateSelectorWin.getInstance().showThisWin(charge, "ADVANCE_CHARGE", params, this);
    },
    // 增加、修改、删除调整 add/edit/del  [isAr 代收 true 垫付 false]
    async addCostAdjust(editMode, isAr) {
      let charge = null
      if (editMode === 'add') {
        charge = new Charge().fillDefaultValue().getData()
        charge.businessDate = this.job.businessDate
        charge.advance = true // 代收垫付
        charge.branchId = this.$store.getters.currentOfficeId
        const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
        charge.localCurrency = localCurrency
        charge.quantity = 1.000
      } else {
        const rows = this.readSelectedRows(!isAr ? 'up' : 'down')
        if (rows && rows.length !== 1) {
          this.$message.info(this.$t('SeaExport.SelectAPieceOfData'))
          return
        }
        charge = rows[0]
      }
      if (charge && (charge.offsetState === 1 || charge.offsetState === 2)) {
        if (editMode === 'edit') {
          this.$message.info(this.$t('SeaExport.RedOffsetCannotModified'))
          return
        } else if (editMode === 'del') {
          this.$message.info(this.$t('SeaExport.RedOffsetCannotDeleted'))
          return
        }
      }
      this.adjustWindow.defaultProperties.editMode = editMode
      this.adjustWindow.defaultProperties.isAdjust = true
      this.adjustWindow.defaultProperties.isAdvance = true
      this.adjustWindow.defaultProperties.needMakeInvoice = false
      this.adjustWindow.defaultProperties.isAr = isAr
      this.adjustWindow.defaultProperties.job = this.job
      this.adjustWindow.defaultProperties.charge = charge
      this.adjustWindow.defaultProperties.needInvoiceNo = true
      this.adjustWindow.defaultProperties.dataSources = 'advanceChargeInfo'
      this.adjustWindow.visible = true
    },
    // 费用调整回调函数
    callbackHandler() {
      this.agentSelected = null
      this.advanceSelected = null
      this.loadCharges()
      // _job.reloadCharges2(loadChargesResultHandler, loadChargesFaultHandler);
    },
    // 垫付 动态列
    getDynamicColumnDefsForUp() {
      // console.log('getDynamicColumnDefsForUp 垫付 动态列 执行')
      return [
        {
          headerName: '', width: 40, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'), field: 'chargeItemId', width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.currentViewCacheData.chargeItemSet],
              methodParams: { advance: true },
              tagValue: 'itemId',
              tagName: this.language === 'zh' ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.language === 'zh' ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_settleAccountsTo'), field: 'accountId', width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          },
          editable: (params) => this.isEdit && this.isEditColumn(params) && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.internal') }, { code: true, value: this.$t('SeaExport.overseas') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'), field: 'currency', width: 180,
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currentViewCacheData.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unit'), field: 'measure', width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_amount'), field: 'quantity', width: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'), field: 'unitRate', width: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'), field: 'exchangeRate', width: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_amount'), field: 'amount', width: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_remarks'), field: 'remarks', width: 180,
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_status'), field: 'chargeState', width: 180,
          // colId: 'chargeState',
          valueFormatter: (params) => {
            return ColumnUtils.chargeStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_billNo'), field: 'billNo',
          // colId: 'billNo',
          width: 180
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_taxNo'), field: 'invoiceNo',
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onCellChange(p),
          width: 180
        },
        {
          headerName: this.$t('FinanceManage.charge_theAmountOfWriteOffs'), field: 'verifiedAmount',
          // colId: 'verifiedAmount',
          cellClass: 'ag-right-aligned-cell',
          width: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('Payment.amountNotWrittenOff'), field: 'chargeUnverifiedAmount',
          cellClass: 'ag-right-aligned-cell',
          width: 180,
          valueFormatter: (params) => {
            return params.data.amount > 0 ? this.$numeral(params.data.amount - params.data.verifiedAmount).format('0.00') : '0.00'
          }
        },
        { headerName: this.$t('FinanceManage.charge_paymentApplicationNo'),
          // colId: 'paymentNo',
          field: 'paymentNo', width: 180 },
        {
          headerName: this.$t('FinanceManage.charge_drawABillOrNot'),
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          colId: 'needInvoice',
          field: 'needInvoice',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        }
      ]
    },
    // 代收 动态列
    getDynamicColumnDefsForDown() {
      // console.log('getDynamicColumnDefsForDown 垫付 动态列 执行')
      return [
        {
          headerName: '', width: 40, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'), field: 'chargeItemId', width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.currentViewCacheData.chargeItemSet],
              methodParams: { advance: true, active: true },
              tagValue: 'itemId',
              tagName: this.language === 'zh' ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.language === 'zh' ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_settleAccountsTo'), field: 'accountId', width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          },
          editable: (params) => this.isEdit && this.isEditColumn(params) && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.internal') }, { code: true, value: this.$t('SeaExport.overseas') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'), field: 'currency', width: 180,
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currentViewCacheData.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unit'), field: 'measure', width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_amount'), field: 'quantity', width: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'), field: 'unitRate', width: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'), field: 'exchangeRate', width: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          },
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_amount'), field: 'amount', width: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_remarks'), field: 'remarks', width: 180,
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_status'), field: 'chargeState',
          // colId: 'chargeState',
          width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.chargeStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_billNo'), field: 'billNo',
          // colId: 'billNo',
          width: 180
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_taxNo'), field: 'invoiceNo',
          editable: (params) => this.isEdit && this.isRowEdit(params.data),
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => this.onCellChange(p),
          width: 180
        },
        {
          headerName: this.$t('FinanceManage.charge_theAmountOfWriteOffs'), field: 'verifiedAmount',
          // colId: 'verifiedAmount',
          cellClass: 'ag-right-aligned-cell',
          width: 180,

          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('Payment.amountNotWrittenOff'), field: 'chargeUnverifiedAmount',
          cellClass: 'ag-right-aligned-cell',
          width: 180,
          valueFormatter: (params) => {
            return params.data.amount > 0 ? this.$numeral(params.data.amount - params.data.verifiedAmount).format('0.00') : '0.00'
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_drawABillOrNot'),
          headerClass: 'ag-header-cell-center',
          cellStyle: {
            textAlign: 'center'
          },
          colId: 'needInvoice',
          field: 'needInvoice',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        }
      ]
    },
    // 列编辑触发事件
    async onCellChange(params) {
      const { node, data } = params
      if (params.colDef.field === 'exchangeRate') {
        const exchangeRate = CurrencyUtil.truncateRateByCurrency(data.currency, data.exchangeRate)
        if (exchangeRate !== data.exchangeRate) {
          node.setDataValue('exchangeRate', exchangeRate)
          return
        }
      }
      const newParams = {
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        originalValue: params.oldValue
      }
      await this.chargeGridItemEditEndHandler(newParams)
    },
    // 应收,应付用同一个事件
    async chargeGridItemEditEndHandler(params) {
      const charge = params.data
      charge.modifiedBy = this.$store.getters.userId
      charge.dateModified = DateUtils.formatStandardDateTime(new Date())
      await this.gridDataFieldChanged(params)
      this.getAdList()
      // 记录修改过的费用
      if (charge.uuid && this.charges && !this.charges.includes(charge)) {
        this.saveCharges(null, charge, null)
      }
      if (charge.receivable) {
        this.down.gridApi.refreshCells({ force: true })
      } else {
        this.up.gridApi.refreshCells({ force: true })
      }
    },
    getAdList() {
      this.adList.arTotalGroup = this.getCharges(this.down.rowData)
      this.adList.apTotalGroup = this.getCharges(this.up.rowData)
      this.adList.revenueTotalGroup = this.getTotalCharges()
    },
    getCharges(charges) {
      const ars = []
      ars.push(...charges)
      return ars
    },
    getTotalCharges() {
      let charge = null
      const results = []
      for (charge of this.down.rowData) {
        results.push(charge)
      }
      for (charge of this.up.rowData) {
        results.push(charge)
      }
      return results
    },
    // 表格列编辑联动
    async gridDataFieldChanged(params) {
      const charge = params.data
      switch (params.field) {
        case 'chargeItemId': {
          charge.chargeItemId = params.value
          await this.chargeItemChange(charge)
          break
        }
        case 'accountId': {
          charge.accountId = params.value
          await this.accountIdChange(charge)
          break
        }
        case 'currency': {
          charge.currency = params.value
          await this.currencyChange(charge)
          break
        }
        case 'measure': {
          charge.measure = params.value
          await this.measureChange(charge)
          break
        }
        case 'quantity': {
          charge.quantity = params.value
          this.quantityAndUnitRateChange(charge)
          break
        }
        case 'unitRate': {
          charge.unitRate = params.value
          this.quantityAndUnitRateChange(charge)
          break
        }
        case 'exchangeRate': {
          charge.exchangeRate = params.value
          await this.exchangeRateChange(charge)
          break
        }
        default: {
          break
        }
      }
    },
    // 费用项目
    async chargeItemChange(charge) {
      await ChargeUtils.chargeItemChange(charge, this.job)
      if (isNaN(charge.quantity) || charge.quantity === 0) {
        await this.refreshQuantity(charge)
      }
      this.refreshAmount(charge)
      if (charge.accountId === 0) { // 与修改 accountId 一样
        await this.accountIdChange(charge)
      } else if (!charge.currency) { // 与修改 currency 一样
        await this.currencyChange(charge)
      } else if (!charge.measure) { // 与修改 measure 一样
        await this.measureChange(charge)
      }
    },
    // 结算对象
    async accountIdChange(charge) {
      charge.quantity = Number(ChargeUtils.ToFixed(charge.quantity, 3))
      this.refreshAmount(charge)
      if (charge.accountId > 0) {
        await ChargeUtils.getChargeisOverseaNotControlledByConfig(charge)
        await ChargeColumnUtil.getInvoiceTitle(charge)
        Company.getCompanyById(charge.accountId).then(cmp => {
          if (cmp) {
            charge.oversea = (cmp.designationAgent || cmp.overseaAgent)
            if (parseInt(cache.config.get('canChangeOverseaOfCharge')) === 2) {
              charge.oversea = false
            } else if (parseInt(cache.config.get('canChangeOverseaOfCharge')) === 3) {
              charge.oversea = true
            }
          }
        })
      }
    },
    // 币种
    async currencyChange(charge) {
      const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
      charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, this.job, charge.branchId)
      await this.refreshUnitRate(charge)
      this.refreshAmount(charge)
    },
    // 单位
    async measureChange(charge) {
      await this.refreshQuantity(charge)
      this.refreshAmount(charge)
    },
    // 数量 单价
    quantityAndUnitRateChange(charge) {
      charge.quantity = Number(ChargeUtils.ToFixed(charge.quantity, 3))
      this.refreshAmount(charge)
    },
    // exchangeRate 汇率
    async exchangeRateChange(charge) {
      const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
      const oldExchange = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, this.job, charge.branchId)
      const oldUnitRate = charge.unitRate * oldExchange
      charge.unitRate = oldUnitRate / charge.exchangeRate
      this.refreshAmount(charge)
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>

<style lang="scss">
.advance-charge-info {
}
</style>
